import React, { useEffect, useMemo, useState } from "react";
import styles from "./AgencyDashboardTabs.module.scss";
import TargetReminder from "./NextMonthTargetPopup/TargetReminder";
import DashboardLoader from "./MainLoader/DashboardLoader";
import getclientNameById from "../../../../components/functions/getclientNameById";
import { divide, get, isNumber, min } from "lodash";
import Tooltip from "./Tooltip";
import MetricsModal, { SavedValues } from "./MetricsModal/MetricsModal";
import {
  GASendEvent,
  getAgencyDashboardMetrics,
  getLocalUser,
  getMonthShortName,
  getYearDataPeriod,
  isNegativeFillColor,
  isPositiveGrowth,
  toLakhs,
} from "../../../../components/functions/utilities";

import {
  setStatus,
  setJobId,
  setRefresh,
  setData,
  setError,
  setBannerVisible,
  setIsTemp,
  resetAgDashboard,
} from "../../../../redux/agencyDashboard/agencyDashboardSlice";
import { RestS } from "../../../../rest/rest-service";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import WelcomeBanner from "./WelcomeBanner/WelcomeBanner";
import MeritoButton from "../../../../components/common/MeritoButtons/MeritoButtons";
import {
  RiArrowRightUpLine,
  RiArrowRightDownLine,
  RiCloseCircleFill,
  RiSubtractLine,
} from "react-icons/ri";
import DashboardCustomDateRange from "../DashboardCustomDateRange/DashboardCustomDateRange";
import { IoMdCalendar } from "react-icons/io";
import {
  HiArrowNarrowRight,
  HiCheckCircle,
  HiChevronDown,
} from "react-icons/hi";
import { BiLinkExternal as RedirectIcon } from "react-icons/bi";
import { Popover } from "react-tiny-popover";
import CalendarDropDown from "./CalendarDropDown/CalendarDropDown";
import { Link } from "react-router-dom";
import ConfirmDialog from "../../../../components/common/ConfirmDialog";
import { setRedirectUrl } from "../../../../redux/temporaryWorkspase/temporaryWorkspace";
import { AiFillExclamationCircle } from "react-icons/ai";
import { GADimensions, GAEvents } from "../../../../interfaces/interfaces";
import { MdHistory } from "react-icons/md";
import { cardMediaClasses } from "@mui/material";
import { start } from "repl";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import Switch from "react-switch";
import ConfettiCanvas from "./ConfettiCanvas/ConfettiCanvas";
import { Modal } from "reactstrap";
import InsufficientData from "./InsufficientData/InsufficientData";
import moment from "moment";
import TargetHistoryModal from "./TargetHistoryModal/TargetHistoryModal";
import CardMetricsTooltipComponent from "./CardMetricsTooltipComponent";
import BrandPage from "./BrandPage/BrandPage";
import useAnalyticsEventTracker from "../../../../components/Hooks/useAnalyticsEventTracker";
import HeaderTitle from "../../../../components/common/HeaderTitle";
import usePageTitle from "../../../../components/Hooks/usePageTitle";
import { useAppSelector } from "../../../../redux/reduxHooks";
import DashboardColdStateV2 from "../dashboardTabs/dashboardTabsContent/ColdState";

// Top-level card keys
export enum TopCardKey {
  TotalBrands = "totalBrands",
  NewBrandsAdded = "newBrandsAdded",
  Sales = "Sales",
  AdSpends = "Ad Spends",
}

// Metrics available inside each brand card
export enum CardMetricKey {
  Sales = "Sales",
  Orders = "Orders",
  AdSpends = "Ad Spends",
  NewCustomers = "New Customers",
  ROAS = "ROAS",
  CostPerOrder = "Cost per Order",
}

// Sales channel keys
export enum SalesChannelKey {
  Shopify = "Shopify Sales",
  Amazon = "Amazon Seller Sales",
  Zepto = "Zepto Sales",
  Instamart = "Instamart Sales",
}

// Ad spend channel keys
export enum AdSpendChannelKey {
  Meta = "Meta Ad Spends",
  Amazon = "Amazon Ad Spends",
  Zepto = "Zepto Ad Spends",
  Instamart = "Instamart Ad Spends",
}

export enum AgJobsStatus {
  InProgress = "IN_PROGRESS",
  Success = "SUCCESS",
  InSufficientData = "INSUFFICIENT_DATA",
  technicalError = "TECHNICAL_ERROR",
  noClientsConnected = 'NO_CLIENTS_CONNECTED',
}


type NumberLike = number | string;

type Growth = {
  pct: number; // e.g. 18.8 -> +18.8%
};

type MetricCell = {
  value: NumberLike;
  targetPct?: number; // if present, show progress bar
  growth?: Growth; // shown only when Show Growth is ON
  negativeBar?: boolean; // paint bar red if true
};

type BrandRow = {
  brand: string;
  sales: MetricCell;
  adSpends: MetricCell;
  roas: MetricCell;
  newCustomers: MetricCell;
  orders: MetricCell;
  cpo: MetricCell; // cost per order
};

type KPIs = {
  totalBrands: NumberLike;
  newBrandsAdded: NumberLike;
  revenueGenerated: NumberLike;
  adSpendsManaged: NumberLike;
};

type Props = {
  kpis?: KPIs;
  rows?: BrandRow[];
  initialShowGrowth?: boolean;
};

function formatINR(n: NumberLike) {
  const num = typeof n === "string" ? parseFloat(n) : n;
  if (isNaN(num)) return n;
  return num.toLocaleString("en-IN").replace(/\.0+$/, "");
}



// Example mapping for icons (optional)
const iconMap: Record<string, string> = {
  Shopify: "/icons/shopify.svg",
  "Amazon Seller": "/icons/amazon.svg",
  Zepto: "/icons/zepto.svg",
  Instamart: "/icons/instamart.svg",
};

function GrowthBadge({
  pct,
  positive,
  type,
  positiveState,
}: {
  pct: number | string;
  positive: boolean;
  type: string;
  positiveState: string;
}) {
  return (
    <div
      className={styles.growthBadge}
      data-positive={
        type === "NEUTRAL" ? "neutral" : positive ? "true" : "false"
      }
    // title={`${positive ? "+" : ""}${pct}% vs prior`}
    >
      {type === "INCREASE" ? <RiArrowRightUpLine /> : <RiArrowRightDownLine />}
      <span>{`${pct === "-" || pct === 0 ? "-" : Math.abs(Number(pct))
        }%`}</span>
    </div>
  );
}

export function GrowthBar({
  pct = 0,
  negative = false,
  ariaLabel,
}: {
  pct?: number;
  negative?: boolean;
  ariaLabel?: string;
}) {
  const clamped = Math.max(0, Math.min(100, pct || 0));
  return (
    <div className={styles.growthBar} role="img" aria-label={ariaLabel}>
      <div className={styles.growthBarTrack} />
      <div
        className={styles.growthBarFill}
        data-negative={negative ? "true" : "false"}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}

// const defaultKpis: KPIs = {
//   totalBrands,
//   newBrandsAdded,
//   revenueGenerated: `₹${formatINR(sales.toFixed(1))}`,
//   adSpendsManaged: `₹${formatINR(adSpends.toFixed(1))}`,
// };

let showWelcomeBanner = true;

export default function BrandSummary({ initialShowGrowth = true }: Props) {
  const [showGrowth, setShowGrowth] = useState<boolean>(initialShowGrowth);
  const user = getLocalUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const kpiList = useMemo(
  //   () => [
  //     { label: "Total Brands", value: kpis.totalBrands },
  //     { label: "New Brands Added", value: kpis.newBrandsAdded },
  //     { label: "Revenue Generated", value: kpis.revenueGenerated },
  //     { label: "Ad Spends Managed", value: kpis.adSpendsManaged },
  //   ],
  //   [kpis]
  // );

  const hasTarget = (metric) =>
    typeof metric?.target === "number" && metric?.targetPerc > 0;
  const [open, setOpen] = useState(false);

  type ChannelMetric = {
    currMonth: number | string;
    prevMonth?: number;
    growth?: any;
    unit?: string;
    target?: number | null;
    targetPerc?: number | null;
    ipId?: string | null;
    channels?: Record<string, ChannelMetric>;
  };

  const clientsObj = useAppSelector(
    (s: RootState) => s.agencyConfig.clientsObj ?? {}
  );

  const refresh = useAppSelector((s: any) => s.agencyDashboard.refresh);
  const dash = useAppSelector((s: any) => s.agencyDashboard.data);
  const status = useAppSelector((s: any) => s.agencyDashboard.status);
  const customDataPeriodStatus = useAppSelector(
    (s: any) => s.agencyDashboard.customDataPeriodStatus
  );
  const isBannerVisible = useAppSelector(
    (s: RootState) => s.agencyDashboard.isBannerVisible
  );
  const isTemp = useAppSelector((s: RootState) => s.agencyDashboard.isTemp);
  const redirectUrl = useAppSelector(
    (s: RootState) => s.temporaryWorkspace.redirectUrl
  );
  const cards = dash?.cards ?? {};

  const [dataPeriod, setDataPeriod] = useState<{
    startMonth: { month: number; year: number };
    endMonth: { month: number; year: number };
  } | null>(() => {
    const dp = dash?.jobDetails?.dataPeriod;
    if (!dp) return null;
    return null;
    // return {
    //   startMonth: {
    //     month: new Date(dp[0]).getMonth(),
    //     year: new Date(dp[0]).getFullYear(),
    //   },
    //   endMonth: {
    //     month: new Date(dp[1]).getMonth(),
    //     year: new Date(dp[1]).getFullYear(),
    //   },
    // };
  });
  usePageTitle("Perform+ | Merito");
  const { headerContent, setHeaderContent, resetHeaderContent } =
    useOutletContext<any>();

  useEffect(() => {
    setHeaderContent(
      <HeaderTitle isNav={false} headerTitle={`${user.name}'s Dashboard`} />
    );

    // setClient(queryParameter.get("client"));
    return () => {
      resetHeaderContent();
    };
  }, []);
  const titleTracker = useAnalyticsEventTracker("Dashboard");

  useEffect(() => {
    titleTracker(document.title);
    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.style.overflowY = "hidden";
    const pageIndexLayout: any = document.getElementById("page_body");
    if (pageIndexLayout) {
      pageIndexLayout.style.overflowY = "hidden";
      pageIndexLayout.style.padding = "0rem";
    }

    return () => {
      const bodyElement = document.getElementsByTagName("body")[0];
      // bodyElement.style.overflowY = "auto";
      const pageIndexLayout: any = document.getElementById("page_body");
      if (pageIndexLayout) {
        pageIndexLayout.style.overflowY = "scroll";
        pageIndexLayout.style.padding = "1rem 1.5rem 2rem 1.5rem";
      }
    };
  }, []);

  useEffect(() => {
    getAgencyDashboardMetrics(dispatch, dataPeriod);
    console.log("getagency metics called here");
  }, [refresh, dataPeriod, customDataPeriodStatus]);
  // customDataPeriodStatus -> because when i change state from the calendar drop down, data is in progress so state wopn't change to wehn it is success then dashboard data shoulb be called from backend

  console.log("dashboard data", dataPeriod);

  useEffect(() => {
    return () => {
      console.log("DashboardPage unmounted — resetting state");
      dispatch(resetAgDashboard());
      console.log("state reset done", dash);
    };
  }, []);

  useEffect(() => {
    if (showWelcomeBanner) {
      dispatch(setBannerVisible(true));
      showWelcomeBanner = false;
    }
  }, []);

  useEffect(() => {
    if (dataPeriod) {
      // if no endMonth and startMonth is current Month then isTemp is false
      if (
        dataPeriod?.startMonth?.month === new Date().getMonth() &&
        dataPeriod?.startMonth?.year === new Date().getFullYear()
      ) {
        dispatch(setIsTemp(false));
      } else {
        dispatch(setIsTemp(true));
      }
    }
  }, [dataPeriod]);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isTemp || isCustomDataInProgress) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isTemp]);

  const getMonthYearText = () => {
    const startRaw = dash?.jobDetails?.dataPeriod?.[0];
    const endRaw = dash?.jobDetails?.dataPeriod?.[1];

    if (!startRaw || !endRaw) return "";

    // Convert "DD-MM-YYYY" → Date object
    const [startDay, startMonth, startYear] = startRaw.split("-").map(Number);
    const [endDay, endMonth, endYear] = endRaw.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return "Invalid date range";
    }

    const startMonthName = start.toLocaleString("en-IN", { month: "short" });
    const endMonthName = end.toLocaleString("en-IN", { month: "short" });
    const startDayStr = String(start.getDate()).padStart(2, "0");
    const endDayStr = String(end.getDate()).padStart(2, "0");

    if (startYear === endYear) {
      return `${startMonthName} ${startDayStr} – ${endMonthName} ${endDayStr}, ${endYear}`;
    }

    return `${startMonthName} ${startDayStr}, ${startYear} – ${endMonthName} ${endDayStr}, ${endYear}`;
  };

  // for Total Brands Card
  const formatAsOfDate = (rawDate?: string): string => {
    if (!rawDate) return "";
    const [day, month, year] = rawDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) return "";

    const monthName = date.toLocaleString("en-US", { month: "short" });
    const dayStr = String(date.getDate()).padStart(2, "0");

    return `${monthName} ${dayStr}, ${year}`;
  };

  const [progressMessage, setProgressMessage] = useState<string | Element>("");

  const set1 = [<>Gathering Sales Data...</>];
  const set2 = [
    "Processing Orders...",
    "Calculating Metrics...",
    "Analysing Performance...",
    "Generating Insights...",
    "Measuring Targets...",
  ];
  const set3 = ["Wrapping Things Up..."];
  const set4 = [
    <>
      If it’s been over a minute, <br /> refresh the page or contact support
    </>,
  ];

  // Flatten them:
  // set2 repeated twice => 10 items
  const repeatedSet2 = [...set2, ...set2]; // 5 + 5
  // Put them all in one sequence for 60 seconds:
  const initialMessageSequence = [...set1, ...repeatedSet2, ...set3];

  // ----------------------------------------------------------------
  // NEW: Manage auto-rotating progress messages
  //     + a final message after 2 minutes if still in progress
  // ----------------------------------------------------------------
  useEffect(() => {
    let intervalId: any;
    let timeoutId: any;

    if (customDataPeriodStatus == "IN_PROGRESS") {
      // Start from the beginning each time we get "In Progress"
      let idx = 0;
      setProgressMessage(initialMessageSequence[idx] as any);

      // Show each message in sequence every 5s, up to the length of initialMessageSequence (12 items = 60s)
      intervalId = setInterval(() => {
        idx += 1;
        if (idx < initialMessageSequence.length) {
          setProgressMessage(initialMessageSequence[idx] as any);
        } else {
          // Once we pass the last message of Set 3, clear the interval
          clearInterval(intervalId);
        }
      }, 5000);

      // After 2 minutes (120s) from the time we started, show Set 4 if still in progress
      timeoutId = setTimeout(() => {
        // Double-check if we are still in progress
        if (customDataPeriodStatus == "IN_PROGRESS") {
          setProgressMessage(set4[0] as any);
        }
      }, 60000);
    } else {
      // If the user is no longer in progress, reset the message
      setProgressMessage("");
    }

    return () => {
      // Cleanup on unmount or if isInProgress becomes false
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customDataPeriodStatus]);
  const [isCustomDataInProgress, setIsCustomDataInProgress] = useState(false);

  useEffect(() => {
    if (customDataPeriodStatus === "IN_PROGRESS" && isTemp) {
      setIsCustomDataInProgress(true);
    } else {
      setIsCustomDataInProgress(false);
    }
  }, [customDataPeriodStatus, isTemp]);

  console.log("customdata in progresssss", isCustomDataInProgress);
  console.log(
    "checkkkkkkkkkkkkkkkkkkk",
    customDataPeriodStatus == "IN_PROGRESS" && isTemp
  );

  const [isTargetHistoryModalOpen, setIsTargetHistoryModalOpen] =
    useState(false);
  const [targetHistoryData, setTargetHistoryData] = useState(null);
  const [isTargetHistoryShown, setIsTargetHistoryShown] = useState(true);
  const [isCloseButtonClicked, setIsCloseButtonClicked] = useState(false);
  useEffect(() => {
    if (isTemp) return;
    RestS.getTargetHistoryForPrevMonth().then((res) => {
      if (!res?.isShown) {
        setTargetHistoryData(res?.data?.data);
        setIsTargetHistoryModalOpen(!res?.data?.isShown);
        setIsTargetHistoryShown(!res?.data?.isShown);
      }
      console.log("DATATATATATTATA", res?.data?.data);
    });
  }, []);

  useEffect(() => {
    if (!isTargetHistoryModalOpen) return;
    if (isCloseButtonClicked) {
      updateTargetHistoryShownStatus();
      return;
    }
    const timer = setTimeout(() => {
      updateTargetHistoryShownStatus();
    }, 2000);

    return () => clearTimeout(timer);
  }, [isTargetHistoryModalOpen]);

  useEffect(() => {
    if (isCloseButtonClicked) {
      // If the close button was clicked, update the target history shown status
      updateTargetHistoryShownStatus();
    }
  }, [isCloseButtonClicked])

  function updateTargetHistoryShownStatus() {
    RestS.setIsShownTargetHistory().then((res) => {
      console.log("target shown post api", res);
      setIsTargetHistoryShown(true);
    });
  }

  console.log("STATUSSSS", status);

  const getTargetPerc = (metricObj) => {
    if (!metricObj || !metricObj?.target || !metricObj?.targetMet) {
      return null;
    } else {
      return `${((metricObj.value / metricObj.target) * 100).toLocaleString(
        "en-IN",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }
      )}`;
    }
  };

  const [
    isTargetHistoryModalByClientIdOpen,
    setIsTargetHistoryByClientIdModalOpen,
  ] = useState(false);
  const [clientNameForTargetHistory, setClientNameForTargetHistory] =
    useState("");

  const getTargetHistoryByClientId = (clientId: number) => {
    RestS.getTargetHistoryByClientId(clientId).then((res) => {
      if (res?.data) {
        setTargetHistoryData(res?.data);
        setIsTargetHistoryByClientIdModalOpen(true);
        setClientNameForTargetHistory(getclientNameById(clientsObj, clientId));
      }
      console.log("DATATATATATTATA", res?.data);
    });
  };

  // if (
  //   status !== AgJobsStatus.Success &&
  //   status !== AgJobsStatus.InSufficientData
  // ) {
  //   return <DashboardLoader />;
  // }
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const navigateToBrandPage = (clientId: number) => {
    navigate(`/dashboard/${clientId}`);
  };

  return (
    <div className={styles.pageBody}>
      {/* <Outlet /> */}
      {status == AgJobsStatus.noClientsConnected ?
        <DashboardColdStateV2 />
        : status !== AgJobsStatus.Success &&
          status !== AgJobsStatus.InSufficientData ? (
          <DashboardLoader />
        ) : (
          <Routes>
            <Route
              index={true}
              element={
                <>
                  {(isTemp
                    ? customDataPeriodStatus === AgJobsStatus.Success
                    : status === AgJobsStatus.Success) && (
                      <>
                        <ConfirmDialog
                          // bodyStyle={{ padding: "1rem 1.5rem" }}
                          size={"md"}
                          showButton={false}
                          visible={redirectUrl && isTemp}
                          toggle={() => dispatch(setRedirectUrl(null))}
                        >
                          <div className={styles.customDpCloseContainer}>
                            <div className={styles.topContainer}>
                              <div className={styles.iconBg}>
                                <AiFillExclamationCircle className={styles.icon} />
                              </div>
                              <div className={styles.title}>
                                {isTemp && "Save this Date Range?"}
                              </div>
                            </div>

                            <div className={styles.textContainer}>
                              <div className={styles.text}>
                                {isTemp &&
                                  "Open a new tab to keep this date range on this tab."}
                              </div>
                            </div>

                            <div className={styles.btnContainer}>
                              <button
                                className={styles.outlinedBtn}
                                onClick={() => {
                                  // navigate them to the page where they were trying to go
                                  const _redirectUrl = redirectUrl;
                                  dispatch(setRedirectUrl(null));
                                  navigate(_redirectUrl);

                                  // Send GA event for section click
                                  const routes = {
                                    "/": "My Dashboard",
                                    "/reports": "My Workspaces",
                                    "/reportdetails": "Workspace",
                                    "/boost": "Merito Boost",
                                    "/settings": "Control Panel",
                                    "/support": "Support",
                                    "/workspacestore": "Workspace Library",
                                  };

                                  try {
                                    console.log(
                                      `/${_redirectUrl.split("/")[1]
                                        }`.toLowerCase(),
                                      routes[
                                      `/${_redirectUrl.split("/")[1]
                                        }`.toLowerCase()
                                      ],
                                      {
                                        [GADimensions.userLoginId]: user.id,
                                        [GADimensions.userType]: user.role,
                                        [GADimensions.section_name]:
                                          routes[
                                          `/${_redirectUrl.split("/")[1]
                                            }`.toLowerCase()
                                          ],
                                        [GADimensions.companyId]: user.companyId,
                                        [GADimensions.companyName]:
                                          user.companyName,
                                      }
                                    );

                                    GASendEvent(user, GAEvents.section_click, {
                                      [GADimensions.userLoginId]: user.id,
                                      [GADimensions.userType]: user.role,
                                      [GADimensions.section_name]:
                                        routes[
                                        `/${_redirectUrl.split("/")[1]
                                          }`.toLowerCase()
                                        ],
                                      [GADimensions.companyId]: user.companyId,
                                      [GADimensions.companyName]: user.companyName,
                                    });
                                    dispatch(setIsTemp(false));
                                  } catch {
                                    console.log(
                                      "error in sending GA event for section click"
                                    );
                                  }
                                }}
                              >
                                Delete Changes
                              </button>

                              <button className={styles.filledBtn}>
                                <Link
                                  to={redirectUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={styles.link}
                                  onClick={() => {
                                    dispatch(setRedirectUrl(null));
                                  }}
                                >
                                  <div className={styles.btnInnerContainer}>
                                    <div className={styles.icon}>
                                      <RedirectIcon />
                                    </div>
                                    <div className={styles.text}>Open New Tab</div>
                                  </div>
                                </Link>
                              </button>
                            </div>
                          </div>
                        </ConfirmDialog>

                        {!isTemp && isTargetHistoryModalOpen && (
                          <>
                            {targetHistoryData &&
                              Object.keys(targetHistoryData).length > 0 && (
                                <ConfettiCanvas />
                              )}
                            {/* <ConfettiCanvas /> */}
                            <TargetHistoryModal
                              targetHistoryData={targetHistoryData}
                              isTargetHistoryModalOpen={
                                isTargetHistoryModalOpen && !isTemp
                              }
                              setIsTargetHistoryModalOpen={
                                setIsTargetHistoryModalOpen
                              }
                              setIsCloseButtonClicked={setIsCloseButtonClicked}
                            />
                          </>
                        )}
                      </>
                    )}

                  <TargetHistoryModal
                    targetHistoryData={targetHistoryData}
                    isTargetHistoryModalOpen={isTargetHistoryModalByClientIdOpen}
                    setIsTargetHistoryModalOpen={
                      setIsTargetHistoryByClientIdModalOpen
                    }
                    isTargetHistoryByClientId={true}
                    isOpenedByDashboard={true}
                    clientName={clientNameForTargetHistory}
                  />

                  <ConfirmDialog
                    // bodyStyle={{ padding: "8px" }}
                    showButton={false}
                    visible={isCustomDataInProgress}
                    // visible={true}
                    // visible={connectionId}
                    toggle={() => {
                      setIsCustomDataInProgress(false);
                    }}
                    // onClick={() =>
                    //   progress > 100 ? setProgress(0) : setProgress(progress + 1)
                    // }
                    showCloseBtn={false}
                    size={"md"}
                  >
                    <div className={styles.dataPeriodLoading}>
                      <div className={styles.progressContainer}>
                        <div className={styles.loaderContainer}>
                          <CircularLoader />
                        </div>
                        <div className={styles.progressText}>
                          {progressMessage}
                        </div>
                      </div>
                      {/* <div className={styles.progressBarContainer}>
                        <div>
                            <ProgressBar
                                completed={progress as any}
                                isLabelVisible={false}
                                bgColor="#100828"
                                width="400px"
                                transitionDuration="3"
                            />
                        </div>
                        <p>{progress}</p>
                    </div> */}
                      {/* <div className={styles.subTitle}>
                        <p>While you wait, you can open Merito in another tab</p>
                        <Link
                            to={"/"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                        >
                            <BiLinkExternal />
                        </Link>
                    </div>
                    <div className={styles.warning}>
                        <AiFillWarning />
                        <p>Do not close this tab</p>
                    </div> */}
                    </div>
                  </ConfirmDialog>
                  {/* <Outlet /> */}
                  <div className={styles.pageHeader}>
                    <div className={styles.monthYear}>{getMonthYearText()}</div>

                    <Popover
                      isOpen={isCalendarOpen}
                      positions={["bottom", "right"]}
                      onClickOutside={() => setIsCalendarOpen(false)}
                      content={
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          <CalendarDropDown
                            onCancel={() => setIsCalendarOpen(false)}
                            dataPeriod={dash?.jobDetails?.dataPeriod}
                            onApply={(val) => {
                              console.log(val);
                              setDataPeriod({ ...val } as any);
                              setIsCalendarOpen(false);
                            }}
                          />
                        </div>
                      }
                      containerStyle={{ zIndex: "9999" }}
                    >
                      <div
                        className={styles.datePicker}
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                      >
                        <div className={styles.leftDatePicker}>
                          <IoMdCalendar />
                          <div className={styles.thisMonth}>
                            {isTemp ? getMonthYearText() : "This Month"}
                          </div>
                        </div>
                        <div className={styles.dropDownPicker}>
                          <HiChevronDown />
                        </div>
                      </div>
                    </Popover>
                  </div>
                  {(isTemp
                    ? customDataPeriodStatus === AgJobsStatus.InSufficientData
                    : status === AgJobsStatus.InSufficientData) && (
                      <InsufficientData />
                    )}
                  {(isTemp
                    ? customDataPeriodStatus === AgJobsStatus.Success ||
                    customDataPeriodStatus === AgJobsStatus.InProgress
                    : status === AgJobsStatus.Success) && (
                      <section
                        className={styles.wrapper}
                        aria-label="Brand Metrics"
                      >
                        {/* <TargetReminder /> */}

                        {/* <div className={styles.brandDetailHeader}>
        <DashboardCustomDateRange />
      </div> */}
                        {!(showWelcomeBanner || isBannerVisible) && (
                          <TargetReminder />
                        )}
                        {(showWelcomeBanner || isBannerVisible) &&
                          Object.keys(cards).length <= 1 && (
                            <div className={styles.welcomeBanner}>
                              <WelcomeBanner />
                            </div>
                          )}

                        <div className={styles.kpis}>
                          <div className={styles.kpi}>
                            <div className={styles.kpiLabel}>
                              {isTemp
                                ? `Total Brands (As of ${moment().format("MMM DD, YYYY")})`
                                : "Total Brands"}
                            </div>
                            <div className={styles.kpiValue}>
                              {dash?.topCards?.totalBrands?.currMonth}
                            </div>
                          </div>
                          <div className={styles.kpi}>
                            <div className={styles.kpiLabel}>New Brands Added</div>
                            <div className={styles.kpiValue}>
                              {dash?.topCards?.newBrandsAdded?.currMonth}
                            </div>
                          </div>
                          <div className={styles.kpi}>
                            <div className={styles.kpiLabel}>Revenue Generated</div>
                            <div className={styles.kpiValue}>
                              ₹
                              {dash?.topCards?.Sales?.currMonth?.toLocaleString(
                                "en-IN",
                                {
                                  maximumFractionDigits: 0,
                                  minimumFractionDigits: 0,
                                }
                              )}
                            </div>
                          </div>
                          <div className={styles.kpi}>
                            <div className={styles.kpiLabel}>Ad Spends Managed</div>
                            <div className={styles.kpiValue}>
                              ₹
                              {dash?.topCards?.[
                                CardMetricKey.AdSpends
                              ]?.currMonth?.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0,
                              })}
                            </div>
                          </div>
                        </div>

                        <div className={styles.card}>
                          <div className={styles.cardHeader}>
                            <h3 className={styles.title}>Brand Summary</h3>
                            <label className={styles.toggle}>
                              <div className={styles.switchContainer}>
                                <Switch
                                  draggable={false}
                                  checked={showGrowth}
                                  onChange={(checked, event) => {
                                    setShowGrowth(checked);
                                  }}
                                  // onChange={(e) => setShowGrowth(e.target.checked)}
                                  onColor="#100828"
                                  offColor="#D5D5D5"
                                  handleDiameter={20}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                  height={24}
                                  width={43}
                                  className={styles.switch}
                                  id="material-switch"
                                />
                              </div>
                              {/* <input
                aria-label="Show Growth"
                type="checkbox"
                checked={showGrowth}
                onChange={(e) => setShowGrowth(e.target.checked)}
              /> */}
                              {/* <span className={styles.switch} /> */}
                              <span className={styles.toggleText}>Show Growth</span>
                            </label>
                          </div>

                          <div className={styles.tableOuter}>
                            <div className={styles.tableContainer}>
                              <table className={styles.table}>
                                <thead>
                                  <tr>
                                    <th>Brand</th>
                                    <th>
                                      <div className={styles.thWrap}>
                                        <span>Sales</span>
                                        <small>(₹ in lakhs)</small>
                                      </div>
                                    </th>
                                    <th>
                                      <div className={styles.thWrap}>
                                        <span>Ad Spends</span>
                                        <small>(₹ in lakhs)</small>
                                      </div>
                                    </th>
                                    <th>ROAS</th>
                                    <th>New Customers</th>
                                    <th>Orders</th>
                                    <th>
                                      <div className={styles.thWrap}>
                                        <span>Cost per Order</span>
                                        <small>(in ₹)</small>
                                      </div>
                                    </th>
                                    <th aria-label="Row actions" />
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries(cards).map(
                                    ([brandId, metrics]: [string, any]) => (
                                      <tr className={`${styles.tableRow} ${isTemp ? styles.disableHover : ''}`}
                                        onClick={() => {
                                          if (isTemp) return;
                                          navigateToBrandPage(Number(brandId));
                                        }}
                                        key={brandId}>
                                        <td className={styles.brandCell}>
                                          <span className={styles.brand}>
                                            {getclientNameById(
                                              clientsObj,
                                              Number(brandId)
                                            )}
                                          </span>
                                        </td>

                                        {/* Sales */}

                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.Sales] ? (
                                            <div className={styles.noDataCell}>
                                              -
                                            </div>
                                          ) : (
                                            <Tooltip
                                              content={
                                                <CardMetricsTooltipComponent
                                                  title="Sales"
                                                  totalDisplay={`${toLakhs(
                                                    metrics[CardMetricKey.Sales]
                                                      ?.currMonth
                                                  )} lakhs`}
                                                  data={
                                                    metrics[CardMetricKey.Sales]
                                                      ?.channels
                                                  }
                                                  dataPeriod={
                                                    dash?.jobDetails?.dataPeriod
                                                  }
                                                />
                                              }
                                            >
                                              <div className={styles.cellContainer}>
                                                <div className={styles.valueRow}>
                                                  <span
                                                    className={`${!isTemp
                                                      ? !isNegativeFillColor(
                                                        metrics[
                                                          CardMetricKey.Sales
                                                        ]?.currMonth,
                                                        "sales",
                                                        metrics[
                                                          CardMetricKey.Sales
                                                        ].target
                                                      )
                                                        ? styles.MetricvalueGreen
                                                        : styles.MetricvalueRed
                                                      : styles.value
                                                      }`}
                                                  >
                                                    {toLakhs(
                                                      metrics?.Sales?.currMonth
                                                    )}
                                                  </span>
                                                  {hasTarget(metrics.Sales) &&
                                                    !isTemp && (
                                                      <span
                                                        className={styles.dim}
                                                      >{` (${metrics?.Sales?.targetPerc
                                                        ?.toLocaleString("en-IN", {
                                                          maximumFractionDigits: 1,
                                                          minimumFractionDigits: 1,
                                                        })
                                                        .replace(
                                                          /([.]0)(?!\d)/,
                                                          ""
                                                        )}%)`}</span>
                                                    )}
                                                </div>

                                                {hasTarget(metrics.Sales) &&
                                                  !isTemp ? (
                                                  <GrowthBar
                                                    pct={metrics.Sales?.targetPerc}
                                                    negative={isNegativeFillColor(
                                                      metrics[CardMetricKey.Sales]
                                                        ?.currMonth,
                                                      "sales",
                                                      metrics[CardMetricKey.Sales]
                                                        .target
                                                    )}
                                                    ariaLabel={`Sales progress ${metrics.Sales?.targetPerc || 0
                                                      }%`}
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                                {showGrowth && (
                                                  <GrowthBadge
                                                    pct={
                                                      metrics[CardMetricKey.Sales]
                                                        .growth?.value
                                                    }
                                                    positive={isPositiveGrowth(
                                                      metrics[CardMetricKey.Sales]
                                                        .growth
                                                    )}
                                                    type={
                                                      metrics[CardMetricKey.Sales]
                                                        ?.growth?.type
                                                    }
                                                    positiveState={
                                                      metrics[CardMetricKey.Sales]
                                                        ?.growth?.positiveState
                                                    }
                                                  />
                                                )}
                                                {hasTarget(metrics.Sales) ||
                                                  isTemp ? (
                                                  ""
                                                ) : (
                                                  <MeritoButton
                                                    type="primary-1"
                                                    size="sm"
                                                    btnText="Set Target"
                                                    isIconToRight={true}
                                                    icon={<HiArrowNarrowRight />}
                                                    extraStyles={{
                                                      alignSelf: "flex-end",
                                                      marginTop: "0.25rem",
                                                    }}
                                                    isRounded={true}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      navigateToBrandPage(
                                                        Number(brandId)
                                                      );
                                                    }}
                                                  />
                                                  // <button
                                                  //   className={styles.ctaPill}
                                                  //   type="button"
                                                  //   onClick={() => setOpen(true)}
                                                  // >
                                                  //   Add Target <span aria-hidden>→</span>
                                                  // </button>
                                                )}
                                              </div>
                                            </Tooltip>
                                          )}
                                        </td>

                                        {/* Ad Spends */}

                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.AdSpends] ? (
                                            <div className={styles.noDataCell}>
                                              -
                                            </div>
                                          ) : (
                                            <Tooltip
                                              content={
                                                <CardMetricsTooltipComponent
                                                  title="Ad Spends"
                                                  totalDisplay={`${toLakhs(
                                                    metrics[CardMetricKey.AdSpends]
                                                      ?.currMonth
                                                  )} lakhs`}
                                                  data={
                                                    metrics[CardMetricKey.AdSpends]
                                                      ?.channels
                                                  }
                                                  dataPeriod={
                                                    dash?.jobDetails?.dataPeriod
                                                  }
                                                />
                                              }
                                            >
                                              <div className={styles.cellContainer}>
                                                <div className={styles.valueRow}>
                                                  <span
                                                    className={`${!isTemp
                                                      ? !isNegativeFillColor(
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.currMonth,
                                                        "spends",
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.target
                                                      )
                                                        ? styles.MetricvalueGreen
                                                        : styles.MetricvalueRed
                                                      : styles.value
                                                      }`}
                                                  >
                                                    {toLakhs(
                                                      metrics["Ad Spends"]
                                                        ?.currMonth
                                                    )}
                                                  </span>
                                                  {hasTarget(
                                                    metrics["Ad Spends"]
                                                  ) &&
                                                    !isTemp && (
                                                      <span
                                                        className={styles.dim}
                                                      >{` (${metrics[
                                                        "Ad Spends"
                                                      ]?.targetPerc
                                                        ?.toLocaleString("en-IN", {
                                                          maximumFractionDigits: 1,
                                                          minimumFractionDigits: 1,
                                                        })
                                                        .replace(
                                                          /([.]0)(?!\d)/,
                                                          ""
                                                        )}%)`}</span>
                                                    )}
                                                </div>

                                                {hasTarget(metrics["Ad Spends"]) &&
                                                  !isTemp ? (
                                                  <GrowthBar
                                                    pct={
                                                      metrics["Ad Spends"]
                                                        ?.targetPerc
                                                    }
                                                    negative={isNegativeFillColor(
                                                      metrics[
                                                        CardMetricKey.AdSpends
                                                      ]?.currMonth,
                                                      "spends",
                                                      metrics[
                                                        CardMetricKey.AdSpends
                                                      ]?.target
                                                    )}
                                                    ariaLabel={`Ad spends progress ${metrics["Ad Spends"]
                                                      ?.targetPerc || 0
                                                      }%`}
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                                {showGrowth &&
                                                  isNumber(
                                                    metrics[CardMetricKey.AdSpends]
                                                      ?.growth?.value
                                                  ) && (
                                                    <GrowthBadge
                                                      pct={
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.growth?.value
                                                      }
                                                      positive={isPositiveGrowth(
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.growth
                                                      )}
                                                      type={
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.growth?.type
                                                      }
                                                      positiveState={
                                                        metrics[
                                                          CardMetricKey.AdSpends
                                                        ]?.growth?.positiveState
                                                      }
                                                    />
                                                  )}
                                                {hasTarget(metrics["Ad Spends"]) ||
                                                  isTemp ? (
                                                  ""
                                                ) : (
                                                  // <button
                                                  //   className={styles.ctaPill}
                                                  //   type="button"
                                                  //   onClick={() => setOpen(true)}
                                                  // >
                                                  //   Add Spend <span aria-hidden>→</span>
                                                  // </button>
                                                  <MeritoButton
                                                    type="primary-1"
                                                    size="sm"
                                                    btnText="Set Budget"
                                                    isIconToRight={true}
                                                    icon={<HiArrowNarrowRight />}
                                                    extraStyles={{
                                                      alignSelf: "flex-end",
                                                      marginTop: "0.25rem",
                                                    }}
                                                    isRounded={true}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      navigateToBrandPage(
                                                        Number(brandId)
                                                      );
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            </Tooltip>
                                          )}
                                        </td>

                                        {/* ROAS */}
                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.ROAS] ? (
                                            <div className={styles.noDataCellTwo}>
                                              -
                                            </div>
                                          ) : (
                                            <div
                                              className={styles.cellContainerTwo}
                                            >
                                              <div className={styles.valueRow}>
                                                <span className={styles.value}>
                                                  {metrics.ROAS?.currMonth?.toFixed(
                                                    1
                                                  )}
                                                </span>
                                              </div>
                                              {showGrowth &&
                                                isNumber(
                                                  metrics[CardMetricKey.ROAS]
                                                    ?.growth?.value
                                                ) && (
                                                  <GrowthBadge
                                                    pct={
                                                      metrics[CardMetricKey.ROAS]
                                                        ?.growth?.value
                                                    }
                                                    positive={isPositiveGrowth(
                                                      metrics[CardMetricKey.ROAS]
                                                        ?.growth
                                                    )}
                                                    type={
                                                      metrics[CardMetricKey.ROAS]
                                                        ?.growth?.type
                                                    }
                                                    positiveState={
                                                      metrics[CardMetricKey.ROAS]
                                                        ?.growth?.positiveState
                                                    }
                                                  />
                                                )}
                                            </div>
                                          )}
                                        </td>

                                        {/* New Customers */}
                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.NewCustomers] ? (
                                            <div className={styles.noDataCellTwo}>
                                              -
                                            </div>
                                          ) : (
                                            <div
                                              className={styles.cellContainerTwo}
                                            >
                                              <div className={styles.valueRow}>
                                                <span className={styles.value}>
                                                  {typeof metrics["New Customers"]
                                                    ?.currMonth === "number"
                                                    ? formatINR(
                                                      metrics["New Customers"]
                                                        ?.currMonth
                                                    )
                                                    : metrics["New Customers"]
                                                      ?.currMonth}
                                                </span>
                                              </div>
                                              {showGrowth &&
                                                isNumber(
                                                  metrics[
                                                    CardMetricKey.NewCustomers
                                                  ]?.growth?.value
                                                ) && (
                                                  <GrowthBadge
                                                    pct={
                                                      metrics[
                                                        CardMetricKey.NewCustomers
                                                      ]?.growth?.value
                                                    }
                                                    positive={isPositiveGrowth(
                                                      metrics[
                                                        CardMetricKey.NewCustomers
                                                      ]?.growth
                                                    )}
                                                    type={
                                                      metrics[
                                                        CardMetricKey.NewCustomers
                                                      ]?.growth?.type
                                                    }
                                                    positiveState={
                                                      metrics[
                                                        CardMetricKey.NewCustomers
                                                      ]?.growth?.positiveState
                                                    }
                                                  />
                                                )}
                                            </div>
                                          )}
                                        </td>

                                        {/* Orders */}
                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.Orders] ? (
                                            <div className={styles.noDataCellTwo}>
                                              -
                                            </div>
                                          ) : (
                                            <div
                                              className={styles.cellContainerTwo}
                                            >
                                              <div className={styles.valueRow}>
                                                <span className={styles.value}>
                                                  {typeof metrics.Orders
                                                    ?.currMonth === "number"
                                                    ? formatINR(
                                                      metrics.Orders?.currMonth
                                                    )
                                                    : metrics.Orders?.currMonth}
                                                </span>
                                              </div>
                                              {showGrowth &&
                                                isNumber(
                                                  metrics[CardMetricKey.Orders]
                                                    ?.growth?.value
                                                ) && (
                                                  <GrowthBadge
                                                    pct={
                                                      metrics[CardMetricKey.Orders]
                                                        ?.growth?.value
                                                    }
                                                    positive={isPositiveGrowth(
                                                      metrics[CardMetricKey.Orders]
                                                        ?.growth
                                                    )}
                                                    type={
                                                      metrics[CardMetricKey.Orders]
                                                        ?.growth?.type
                                                    }
                                                    positiveState={
                                                      metrics[CardMetricKey.Orders]
                                                        ?.growth?.positiveState
                                                    }
                                                  />
                                                )}
                                            </div>
                                          )}
                                        </td>

                                        {/* CPO */}
                                        <td className={styles.metricCell}>
                                          {!metrics[CardMetricKey.CostPerOrder] ? (
                                            <div className={styles.noDataCellTwo}>
                                              -
                                            </div>
                                          ) : (
                                            <div
                                              className={styles.cellContainerTwo}
                                            >
                                              <div className={styles.valueRow}>
                                                <span className={styles.value}>
                                                  {metrics[
                                                    "Cost per Order"
                                                  ]?.currMonth.toFixed(1)}
                                                </span>
                                              </div>
                                              {showGrowth &&
                                                isNumber(
                                                  metrics[
                                                    CardMetricKey.CostPerOrder
                                                  ]?.growth?.value
                                                ) && (
                                                  <GrowthBadge
                                                    pct={
                                                      metrics[
                                                        CardMetricKey.CostPerOrder
                                                      ]?.growth?.value
                                                    }
                                                    positive={isPositiveGrowth(
                                                      metrics[
                                                        CardMetricKey.CostPerOrder
                                                      ]?.growth
                                                    )}
                                                    type={
                                                      metrics[
                                                        CardMetricKey.CostPerOrder
                                                      ]?.growth?.type
                                                    }
                                                    positiveState={
                                                      metrics[
                                                        CardMetricKey.CostPerOrder
                                                      ]?.growth?.positiveState
                                                    }
                                                  />
                                                )}
                                            </div>
                                          )}
                                        </td>

                                        {/* Row action */}
                                        <td
                                          className={`${styles.actionCell} ${styles.fixedCol}`}
                                        >
                                          {isTemp ? (
                                            <MeritoButton
                                              size="md"
                                              type="secondary-1"
                                              icon={<MdHistory />}
                                              btnText="History"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                getTargetHistoryByClientId(
                                                  Number(brandId)
                                                );
                                              }}
                                            />
                                          ) : (
                                            <button
                                              type="button"
                                              className={styles.iconBtn}
                                              aria-label={`More actions for ${getclientNameById(
                                                clientsObj,
                                                Number(brandId)
                                              )}`}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                navigateToBrandPage(Number(brandId))
                                              }}
                                            >
                                              +
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </section>
                    )}
                </>
              }
            />
            <Route path="/:brandId" element={<BrandPage />} />
          </Routes>
        )}
    </div>
  );
}
